<div class="modal-header">
  <h4 class="modal-title pull-left">Modifica marca {{ name }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="errorMessage" class="alert alert-danger my-3">
    {{ errorMessage }}
  </div>
  <mat-slide-toggle
    color="primary"
    (change)="activeChecked = !activeChecked; didUserEdit = true"
    [checked]="activeChecked"
  >
    Attivo
  </mat-slide-toggle>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="onEditClick()"
    [disabled]="!didUserEdit || isLoading"
  >
    <span
      *ngIf="isLoading"
      class="spinner-border spinner-border-sm mr-1"
    ></span>
    Effettua modifiche
  </button>
</div>
